export enum EcpErrors {
  noSearchValue = 'noSearchValue',
  errorValue = 'errorValue',
}
